export default __webpack_public_path__ + "static/media/D_Shop.7b5b6461.png";